module.exports = __webpack_public_path__ + "img/primario.a0b348f1.jpg";